export default {
    welcome: 'bienvenue à Smartee.cn',
    login: 'connexion',
    register: 'inscrire',
    loginTitle: 'page de connexion',
    registerTitle: "page d 'inscription",
    forgetTitle: 'mot de passe oublié',
    mine: 'mon',
    username: 'numéro de compte',
    password: 'mot de passe',
    conformPassword: 'confirmer le mot de passe',
    forget: 'mot de passe oubli',
    inputCount: 'entrez un numéro de compte',
    mobile: 'entrez votre numéro de téléphone',
    refCode: 'obtenir le code de vérification',
    code: 'code de vérification',
    inputPassword: 'entrez votre mot de passe',
    inputConformPassword: 'entrez à nouveau votre nouveau mot de passe',
    passwordlg6: 'le mot de passe ne peut pas être inférieur à 6 chiffres!',
    hascount: 'compte existant',
    agreeIt: "cochez la case 'accepter les termes de l'accord d' inscription d'utilisateur Smartee'",
    verifynotise: 'remplissez le code de vérification',
    passwordSame: 'les deux de passe doivent être les mêmes',
    passwordDiff: 'les deux mots de passe ne sont pas identiques!',
    agree: "accepter 'l'Accord d'inscription d'utilisateur Smartee'",
    acount: 'identifiant',
    surname: 'nom',
    name: 'prénom',
    sex: 'sexe',
    male: 'masculin',
    female: 'féminin',
    contactNumber: 'numéro de téléphone',
    email: 'e-mail',
    medicalInstitution: "désignation de l'hôpital",
    zipCode: 'code postal',
    hospitalAddress: "adresse de l'hôpital",
    finish: 'terminer',
    save: 'enregistrer',
    cancel: 'annuler',

    care: 'focus sur',
    undone: 'en attente de traitement',
    unsubmit: 'en attente de soumission',

    done: 'en cours de traitement',
    finished: 'terminé',
    addPatient: 'ajouter un patient',
    patientName: 'nom du patient',
    productLine: 'série produit',
    createTime: 'date de création',
    organizationName: "désignation de l'hôpital",
    clinicalOperation: 'opération clinique',
    caseProgress: 'avancement de cas',

    allResult: 'tous les résultats',
    sex2: 'sexe',
    yearold: 'âge',
    qingkuang: "situation d'examen",
    methods: 'méthode de correction',
    biaoje: 'marque',
    all: 'tous',
    femail: 'masculin',
    mail: 'féminin',
    features: 'caractéristique',
    orthodonticTreatment: 'méthode de correction',
    caseStatus: 'état de cas',
    onlyready: 'lecture seule',

    mangement: 'gestion de cas',
    total: 'statistiques de cas',
    inputPatientName: 'entrez le nom du patient',
    scan: 'balayage à un bouton',
    zh: 'chinois simplifié',
    en: 'anglais',
    es: 'Espagnol',
    fr: 'Le français',
    dashboard: 'accueil',
    screenfull: 'plein écran',
    size: 'taille',

    messageType: 'type de message',
    messageContent: 'contenu du message',
    messageStatic: 'état du message',
    scanfile: 'balayer le fichier',
    tooth: 'dent',
    toothfile: 'fichier de dent',
    casestatus: 'état de cas',
    transferredcases: 'cas transit',
    transfernewcases: 'nouveau cas',
    usescan: 'lancer le balayage à un bouton Smartee',

    smarteeusescan: 'balayage à un bouton Smartee',
    basemessage: 'information de base',
    selectionLines: 'sélection de série produit',
    mismatchType: 'type de désalignement',
    photoUpload: 'chargement de photo ',
    otherPhotos: 'autres photos',
    xUpload: 'charger le film radiographique',
    caseform: 'formulaire de soumission de cas',
    submission: 'soumettre',
    storage: 'enregistrer temporairement',
    next: 'étape suivante',
    last: 'étape précédente',
    patientMessage: 'information du patient',
    affiliatedHospital: 'hôpital affilié',
    contactNumber: 'numéro de téléphone',
    receivingAddress: 'adresse de livraison',
    productLine: 'série produit',
    smartee1: 'Smartee GE',
    classicVersion: 'version classique',
    smartee2: 'Smartee Pre+ ',
    prideEdition: 'version privilège',
    smartee3: 'Smartee U+ ',
    youthVersion: 'version jeunesse ',
    angletype: "type d'angle",
    mismatchtype: 'type de désalignement',
    faceLeft: 'position latérale du visage ',
    faceLateral: 'position face du visage',
    faceSmile: 'sourire du visage',
    upperDentition: 'dentition supérieure',
    lowerDentition: 'dentition inférieure',
    rightImage: 'image intra-orale de la positon droit',
    intraoralImage: 'image intra-orale de position face',
    leftImage: 'image intra-orale de la positon gauche',
    photosDel: 'vous pouvez charger des photos en vrac, double-cliquer pour supprimer',
    uploadPhotos: 'charger les photos',
    enterPhotoLocation: 'entrez les informations sur la position de la photo',
    title: 'données personnelles',
    phone: 'numéro de portable',
    telephone: 'numéro de téléphone fixe',
    city: 'ville',
    quality: 'certificat de qualification de médecin',
    info: 'introduction',
    addressmanagement: 'gestion d’adresse',
    setting: 'paramètres de sécurité',


    childcountsetting: 'paramètres du sous-compte',
    preferences: 'préférence clinique',
    multipointPhysician: 'médecin multipoint',
    IsCase: 'droit de cas',
    IsFinance: 'droit financier',
    casemanagement: 'gestion de cas',
    casesStatistic: 'statistiques de cas',
    permission: 'statistiques de cas',
    pagePermission: 'focus sur',
    directivePermission: 'en attente de traitement',

    refresh: 'rafraîchir',
    close: 'fermer',
    closeOthers: 'fermer les autres',
    closeAll: 'fermer tout',
    angle1: 'angle typeⅠ',
    angle2: 'angle typeⅡ',
    angle3: 'angle type Ⅲ',
    uncertain: 'incertain',
    crowding: 'encombrement',
    dentitionClearance: 'écart de dentition',
    Protrusion: 'saillie',
    openjaw: 'mâchoire ouverte',
    anteriorCrossbite: 'anti-mâchoire antérieur',
    anterior: 'dents antérieures',
    rightTeeth: 'dents postérieures droits',
    leftTeeth: 'dents postérieurs gauches',
    posteriorCrossbite: 'anti-mâchoire postérieur',
    deepCoverage: 'couverture profonde',
    deepOverbite: 'supraclusion profonde',
    other: 'autre',
    surfaceFault: 'défaut de surface',
    lateralCranium: 'cranium latéral',
    uploadCBCT: 'charger CBCT',
    uploadFiles: 'charger le fichier',
    choseModelFiles: 'sélectionnez un fichier de modèle numérique',
    browse: 'parcourir',
    otherXray: "charger d'autres films radiographiques",
    inputOtherXray: 'entrez les informations sur la position de film radiographique',
    chiefComplaint: 'plainte principale',
    unevenTeeth: 'dents inégales',
    diastema: 'écart de dent ',
    dentalProtrusion: 'saillie dentaire',
    dentofacialJaw: 'anti-mâchoire dentaire',

    majorObjectives: 'objectif principal',
    arrangeTeeth: 'arranger les dents',
    closingDentitionSpace: "fermer de l'espace de dentition",
    improvementProfile: 'améliorer le profil',
    correctingJaw: "correction de l'anti-mâchoire",
    orthodonticTeeth: 'mâchoire dentaire à corriger',
    orthodonticsDescribe: "même les corrections à une mâchoire nécessitent la soumission d'une empreinte en caoutchouc de silicone sur le mâchoire entière ou d'un fichier numérique",
    wholeJaw: 'mâchoire entière',
    maxillary: 'mâchoire supérieure',
    mandible: 'mâchoire inférieure ',
    toothInformation: 'information dentaire',
    toothnotise: 'note: les dents manquantes sont grises et les dents caduques sont vertes. si les dents caduques sont cochés, la radiographie est obligatoire.',
    noDeletion: 'sans manque',
    noDeciduousTeeth: 'sans dent caduque',
    deciduousTeeth: 'les dents suivantes sont des dents caduques',
    teethmiss: 'les dents suivantes sont des dents manquantes',
    submitTeethModel: 'soumettez un modèle de dent',
    faceShape: 'forme du visage',
    siliconeRubberModel: 'modèle en caoutchouc de silicone',
    siliconeRubberImpression: 'empreinte en caoutchouc de silicone',
    siliconeRubberRecord: 'enregistrement d’occlusion de caoutchouc de silicone',
    courier: 'numéro de courrier',
    courierNumber: 'entrez le numéro de courrier',
    seachCourier: 'après avoir entré le numéro de courrier, vous pouvez appuyer sur Entrer pour vérifier les informations de courrier ou cliquer sur le bouton pour vérifier les informations de courrier.',
    courierNotise: 'note: veuillez envoyer le numéro de soumission avec le modèle pour que le destinataire Smartee le vérifie.',
    modelFiles: 'fichier de modèle numérique',
    localFile: 'fichier local',
    shape3: "3Shape/ données d'analyse orale Sirona",
    upload: 'charger',
    mattersNeedingAttention: 'précautions',
    saveSTL: 'enregistrer au format STL;',
    includeScans: "il faut inclure les enregistrements d'analyse de la mâchoire supérieure, inférieure et occlusion;",
    includeZip: 'charger sous forme de package compressé (le type de fichier doit être .rar / .zip).',
    shape: '3Shape',
    shape3web: 'connectez-vous au site 3Shape',
    shape3user: 'entrez votre identifiant et votre mot de passe 3Shape',
    shape3qq: 'ajoutez le compte de la sociét Smartee "48150554@qq.com" pour envoyer les données numérisées par TRIOS au compte',
    sinold: "données d'analyse orale Sirona",
    sinoldCount: 'connectez-vous à votre compte Sirona',
    addSmarteeCount: 'ajoutez le compte de la société Smartee "Smartee" et envoyez les données numérisées au compte',
    sendEmail: "vous pouvez envoyer des fichiers zip, rar ou stl à case@smartee.cn. Veuillez écrire 'nom de l'établissement + nom du médecin + nom du patient' pour le titre de l'e-mail.'",
    patientDetails: 'détails du patient',
    patientHome: "page d'accueil du patient",
    endTherapy: 'fin de traitement',
    lateHolderShipped: 'retenue ultérieure expédiée',
    expressType: 'type de courrier',
    chinaExpress: 'Zhongtong Express',
    sfExpress: 'SF Express',
    logisticsNumber: 'numéro de commande logistique',
    lateStageDelivery: "prévision d'expédition de retenue ultérieure",
    endTreatmentConfirmed: 'fin de traitement confirmée',
    laterStageHolderProcessing: 'retenue ultérieure en cours de traitement',
    estimatedDelivery: 'temps d’expédition estimé de retenue ultérieure',
    confirmationTreatment: 'confirmation de fin de traitement',
    see: 'voir',
    fineTuning: 'réglage fin',
    productionStage: 'étape de production ',
    delivery: 'expédition',
    firstStage: 'première étape',
    appliancesShipped: 'retenue expédié',

    totalMaxillarySteps: 'nombre total d’étapes pour la mâchoire supérieure',
    totalMandibularSteps: 'nombre total d’étapes pour la mâchoire inférieure',
    numberDeliverySteps: "nombre d'étapes dans cette expédition",
    ShipmentForecast: "prévision d'expédition",
    FineTuningDesignConfirmed: 'conception de réglage fin confirmée',
    ProcessingFineTuned: 'appareil d’alignement à réglage fin en cours de traitement',
    totalMaxillarySteps: 'temps d’expédition estimé de appareil d’alignement à réglage fin',
    finelyAdjustDeliveryTime: 'temps d’expédition estimé de appareil d’alignement',
    designPhase: 'étape de conception',
    design3D: 'conception 3D',
    confirmed: 'confirmé',
    confirm: 'confirmer',
    quotation: 'devis',
    receivingInspection: 'vérification de la réception',


    checkQualified: 'vérification  qualifié',
    unqualified: 'vérification déqualifié',
    modelReceived: 'modèle reçu',
    fineTunedCasesSubmitted: 'cas de réglage fin soumis',
    fineTunedCasesTobeSubmit: 'cas précis à soumettre',
    fineTunedCasesStorage: 'enregistrement temporaire prévue de réglage fin',
    completeInformation: 'informations à améliorer, veuillez compléter',
    rearrangingTeeth: 'réarrangement des dents',
    ViewTooth: 'voir l’arrangement',
    followUpConfirmed: 'demande sur le traitement ultérieur confimrée',
    followUpApplication: 'traitement ultérieur demandé',
    followUptoComform: 'traitement ultérieur à confirmer',
    followUpTime: 'temps de traitement ultérieur pour l’appareil d’alignement ',
    residualAppliance: 'appareil d’alignement restant',
    vice: 'adjoint',
    designConfirmed: 'animation de conception confirmée',
    clinicalDoctorsModifications: 'le clinicien propose les observations de modificaton',
    tobeConfirmed: 'à confirmer',
    casesSubmitted: 'cas soumis',
    casesTobeSubmit: 'cas à soumettre',
    hospital: 'hôpital',
    caseCharacteristics: 'caractéristiques de cas',
    impactData: "données d'image",
    group: 'groupe',
    caseInformation: 'données du cas',
    proceduresStage: 'opérations cliniques nécessaires pour cette étape',
    fineAdjustment: 'réglage fin',
    processingFollowUp: 'traitement ultérieur',
    finelyTunedCaseSubmissionForm: 'formulaire de soumission de cas de réglage fin',
    currentAppliancesFit: 'état d’appairage pour l’appareil d’alignement',
    applianceFit: 'appairage pour l’appareil d’alignement',
    judgementBasis: "base de jugement: la relation entre le mouvement de la dent et l'occlusion est fondamentalement conforme à la conception de l'appareil simulé et il n'y a pas d'écart évident entre l'appareil et la dent.",
    appliancesUnfit: "l'appareil d’alignement ne convient pas",
    needmodelfile: 'une empreinte en caoutchouc de silicone à pleine bouche ou un fichier de modèle numérique à pleine bouche doit être soumis.',
    defaultGrind: 'il faut retirez tous les accessoires dans la bouche avant de prendre le gel de silice ; sinon, ils seront réputés avoir été retiré.',
    clinicalExamination: 'examen clinique',
    orthodonticSteps: "le nombre d'étapes pour porter l'appareil lors de ce retour est:",
    isDentitionSpace: 'y a-t-il un écart de dentition?',
    none: 'non',
    have: 'oui',

    left: 'gauche',
    right: 'droit',
    clearanceCheck: "vérification actuelle de l'écart de dentition (mesure précise à l'aide de la  règle de mesure d'écart: note: l'écart ne dépasse pas 2 décimales, exprimé en mm",
    otherCheck: 'autres examens (y compris désalignement des dents, relâchement, exposition précoce, etc.)',
    otherLimited: "dans d'autres cas, limitez-le à 1 000 mots (après une suppression accidentelle, utilisez Ctrl + z pour annuler l'opération).",
    designRequirement: 'exigences de conception de l’étape précédente (en cas de changement, veuillez demander le médecin d’ajuster à temps, sinon notre société poursuivra les exigences de conception de l’étape précédente)',
    NonRemovableTeeth: 'dents non mobiles',
    NonRemovableTeethType: '(dents non mobiles tels que les dents en porcelaine, les ponts de réparation, les implants)',
    followingTeethImmovable: 'les dents suivantes ne sont pas mobiles',
    notDesigned: 'dents qui ne peuvent pas concevoir les accessoires',
    notDesignedType: 'dents en porcelaine, les ponts de réparation , etc. qui ne peuvent pas coller les accessoires',
    NonRemovableDesign: 'les dents suivantes ne sont pas conçues pour être attachées ',
    FlatGuidePlateTeeth: 'plaque de guide plat de les antérieurs',
    suitableCase: "convient pour les cas de couverture peu profonde et d' supraclusion profonde",
    anteriorCentralIncisor: 'dent incisive central de les antérieurs',
    LateralIncisorsAnteriorTeeth: 'dent incisive latéral de les antérieurs',
    anteriorTeeth: 'canine de les antérieurs',
    longDistanceTreatment: "besoin d'une correction à distance?",
    selectYes: 'note: si la case OUI est cochée, toutes les opérations cliniques seront fusionnées dans la première étape de la conception 3D initiale',
    yes: 'oui',
    no: 'non',
    cover: 'couvrir',
    isCommunicate: 'besoin de communiquer avec le service médical Smartee?',
    every3mothsVisit: 'une visite ultérieure tous les 3 mois',
    every6mothsVisit: 'une visite ultérieure tous les 6 mois',
    every12mothsVisit: 'une visite ultérieure tous les 12 mois',
    secondVisit: 'une visite ultérieure',
    unableDetermineReferralPeriod: 'impossible de déterminer le cycle de visite ultérieure',
    followUpOrthodontic: "exigences de correction de suivi (l'objectif de correction initial ne doit pas être modifié)",
    limited: 'entrez moins de 1000 mots',
    unfitPhotographs: 'photo qui montre la partie inapte lors de port l’appareil de alignement',


    unfit: 'non appairage',
    images: 'image',
    photographs: 'photo intra-orale',
    photoface: 'photo à face',

    wholeJaw: 'film de défaut de surface pour le mâchoire entier',
    cephalometric: 'film de positionnement latérale du crâne',
    unsubmit: 'pas soumettre',
    submitDataModel: 'soumettez un modèle numérique complet et clair',
    viewingModelRequirements: 'voir les exigences du modèle',
    boxScanFile: "fichier d'analyse de boîte",
    saveSTL: 'le format d’enregistrement est STL',
    scanList: "il faut contenir un enregistrement d'analyse d’occlusion",

    doctorSignature: 'signature du médecin',
    date: 'date',
    completionOrthodonticTreatment: 'situation sur la corretion terminée',
    whichBelongs: 'confirer la situation sur la corretion terminée',
    achievingCorrectionObjectives: "atteindre l'objectif de correction",
    changeOtherMethods: "la correction invisible permet d'obtenir l'effet d’étape et est remplacée par d'autres méthodes de correction",
    unfinishIquiredOver: 'l’objectif de la correction invisible n’est pas atteint, mais le patient a demandé de terminer la correction',
    inputOthers: "remplissez la zone de saisie pour d'autres raisons",
    finishedPhotos: 'photo après la fin de corretion',
    postWarrantyData: 'données de post-garantie',
    letterAuthorization: "lettre d'autorisation",
    currentPatientName: 'nom du patient actuel',
    hospital: 'hôpital',
    clinic: 'clinique',
    letterSmartee: "accepter la 'Lettre d'autorisation pour la fin de correction invisible'",

    letterPrint: "imprimer la lettre d'autorisation pour la fin de correction invisible",
    canvasDesign: "conception d'animation",
    canvasView: 'voir l’animation',
    gums: 'gencive',
    workSpace: 'surface de travail',
    occlusion: 'occlusion',
    contrast: 'comparaison',
    occlusion: 'occlusion',
    enclosure: 'accessoire',
    grid: 'grille',
    designCommunication: 'communication de conception',
    distributionInformation: 'informations de distribution',
    operation: "notice d'utilisation",
    inputEdit: 'entrez vos commentaires ici',
    agreeProgramme: "utilisez le bouton d'approbation situé dans le coin supérieur droit pour accepter le plan de correction",
    mockProgramme: 'plan de simulation',
    effectDifferent: "l'effet réel du traitement peut être différent",
    animationContrast: "comparaison d'animation",
    transferCases: 'enregistrer et transférer de nouveaux cas',
    scanRescan: 'rebalayage la bouche Smartee',
    checkMouth: 'voir le balayage de la bouche',
    mk: 'MK',
    mainPages: 'interface principale',
    UnderTenyears: 'moins de 10 ans',
    from10to20: '10-20 ans',
    from21to30: '21-30 ans',
    from31to40: '31-40 ans',
    over41: '41 ans et plus',

    interproximalEnamelStripping: "réduction de l'émail interproximal",
    distalMolars: 'distalisation molaire',
    classTraction: 'traction de type Ⅱ/Ⅲ',
    extendedAnteriorTeeth: 'allonger les antérieurs',
    lowerFrontTeeth: 'abaisser les antérieurs',
    archExpansion: "étendre l'arche ",
    pressDown: 'abaisser les antérieurs et lever le prémolaire',
    lipMoveUp: 'déplacer à lèvre les antérieurs supérieurs',
    tongueMovedown: 'déplacer à langue les antérieurs inférieurs',
    maxillaryAnteriorTeeth: 'allonger les antérieurs de mâchoire supérieure',
    mandibleAnteriorTeeth: 'allonger les antérieurs de mâchoire inférieure',
    improveMidline: 'améliorer la ligne médiane',
    midline: 'ligne médiane',
    improvementMaxillaryProtrusion: 'améliorer la saillie de mâchoire supérieure',
    improvementMaxillaryRetraction: 'améliorer la rétraction de mâchoire supérieure',
    improvementMandibularProtrusion: 'améliorer la saillie de mâchoire inférieure',
    improvingMandibularRetraction: 'améliorer la rétraction de mâchoire inférieure',
    sagittalRelationship: 'relation sagittale',
    allJawSilicone: "même les corrections à une mâchoire nécessitent la soumission d'une empreinte en caoutchouc de silicone sur le mâchoire entière ou d'un fichier numérique",
    improve: 'améliorer',
    maintain: 'maintenir',
    firstChoice: 'premier choix',
    optional: 'optionnel',
    notAllowed: 'non autorisé',
    rightUpper: 'supérieur et droit',
    leftUpper: 'supérieur et gauche',
    xRayRequired: 'note : si cette case est cochée, la radiographie est obligatoire',
    maintainingImprovingRelationship: 'maintenir et améliorer la relation dentaire',
    caninesMolars: 'améliorer la relation entre les canine et les molaires',
    adjustmentNeutrality: 'ajuster à la relation neutre',
    moreAdjacentGlazing: "possible de nécessiter plus réduction de l'émail interproximal et extraction dentaire",
    maintainMidline: 'maintenir la ligne médiane',
    maybeRequerEnamelStripping: "(possible de nécessiter la réduction de l'émail interproximal)",
    righttoPatient: 'vers le droit du patient',
    lefttoPatient: 'vers le gauche du patient',
    correctionGap: "correction de l'écart",
    increaseDesigns: 'possible d’ augmenter le temps de modification et le nombre de conceptions 3D',
    righttoPatient: 'vers le droit du patient',
    noSpaceReserved: 'sans écart réservé',
    spaceReserved: 'sans écart réservé',
    adduction: "les antérieurs se contractant vers l'intérieur",
    NearPosteriorTooth: 'les postérieurs se rapprochent',
    lipTilt: 'inclinaison des lèvres',
    toothExtraction: 'extraction de dent',
    notoothExtraction: 'sans extraction de dent',
    correctionCrowding: "correction d'encombrement",
    followingTeeth: 'retirer les dents suivantes',
    sign: 'marque',
    methods: 'méthode',
    intermaxillaryTraction: 'besoin de coopérer avec la traction intermaxillaire',
    caseBank: 'bibliothèque de cas',
    financialManagement: 'gestion financière',
    marketActivity: 'activité de marché',
    messageNotification: 'notification de message',
    messageDetail: 'détails du message',
    wornOut: "l'appareil d’alignement est sur le point d'être porté",
    canvasModified: "plan d'animation modifié",
    fixedTel: 'téléphone fixe',
    definition3Ddesign: 'déterminer après la conception 3D',
    othersSpecified: 'autre (écrit dans des instructions spéciales)',
    openOcclusion: "correction de l'occlusion ouverte",
    deepOverbite: 'correction de la supraclusion profonde',
    overbite: 'supraclusion ',
    backtop: 'retour en haut',
    anteriorTeeth: 'abaisser seulement les antérieurs',
    receiveName: 'destinataire',
    region: 'région',
    addressDetail: 'adresse détaillée',
    telphone: 'contact',
    default: 'par défaut',
    invoiceAddress: 'adresse postale de facturation',
    securitySetting: 'paramètres de sécurité',
    loginPassword: 'mot de passe de cennextion',
    verifyphone: 'vérifier le portable',
    anteriorTeeth: 'occlusion bord à bord des antérieurs',
    anteriorCrossbite: 'croisé des antérieurs',
    posteriorTeeth: 'croisé ou croisé buccal des postérieurs(le cas éventuel)',
    addSubaccounts: 'ajouter un sous-compte ',
    subaccountName: 'identifiant de sous-compte',
    hospitalname: "désignation de l'hôpital",
    access: "attribution d'accès",
    availability: 'est-ce disponible? ',
    notRectify: 'pas corriger',
    rectify: 'corriger',
    designmanage: 'gestion de la conception',
    designValidation: 'confirmer la conception, partager la conception, soumettre les commentaires de communication',
    treatmentManage: 'gestion du traitement',
    editcase: 'rédiger le formulaire de soumission de cas, confirmer le reçu et terminer le traitement',
    sheetView: 'voir le devis',
    maybe: 'est-ce possible? ',
    specialInstructions: 'instructions spéciales',
    wisdomTooth: 'dent de sagesse',
    defaultRemoval: 'extraction par défaut (l’appareil d’alignement ne couvre pas)',
    requirements: 'selon les exigences du plan',
    glazeRemoval: "réduction de l'émail",
    glazeRemovalPositon: "position de la réduction de l'émail",
    frontTeethFirst: 'antérieurs en premier',
    posteriorTeethPreferred: 'postérieurs en premier',
    beautifulDentition: 'belle dentition',
    unwanted: 'pas besoin',
    need: 'besoin dans le cas de l’écart sur la zone antérizures plus de 4mm',
    attachment: 'opération et collage des accessoires',
    doing: 'effectuer',
    DelayStep: 'remettre jusqu’à',

    systemhelp: 'aide système',
    tips: 'remarque',
    consultation: 'vous n’avez pas installé le logiciel Smartee, veuillez contacter le service clientèle ou le service commercial pour onsultation!',
    feeConfirmationForm: 'formulaire de confirmation des frais sur la correction invisible sans support Smartee',
    back: 'retour',
    specificationTable: 'tableau de spécification',
    confirmationAgreement: 'accord de confirmation',
    scanApp: "scannez et téléchargez l'application mobile invisible Smartee",

    clickzoom: "cliquer sur la photo pour l'agrandir",
    semail: 'envoyer le courrier',
    fineTuned: 'appareil d’alignement en cours de traitement',
    followTitle: 'traitement ultérieur ',
    deliveryTotal: 'étape d’expédition',
    total: 'total',
    this: 'cette demande',
    deliveryTime: "temps prévue de la prochaine demande d'expédition",
    fineTunedCases: 'cas de réglage fin',
    submitted: 'soumis ',
    tobeSubmit: 'à soumettre',
    clickUpload: 'cliquer sur modifier ',
    secret: 'confidentialité',
    edit: 'éditer',
    add: 'ajouter',
    isDefault: 'est-ce par défaut? ',

    requiredPhone: 'le numéro de portable ne peut pas être vide',
    requiredPhone11: 'le numéro de portable ne doit pas être inférieur à 11 chiffres',
    requiredRightPhone: 'entrez le numéro de portable correct!',

    requiredPassword: 'le mot de passe ne peut pas être vide',
    requiredPasswordLg6: 'le mot de passe ne peut pas être inférieur à 6 chiffres',

    requiredCode: 'le code de vérification ne peut pas être vide',
    requiredCodelg6: 'le code de vérification est composé au plus de 6 chiffres',

    errorSubmit: 'la soumission a échoué!',
    sendSuccess: 'envoyé avec succès! Vérifiez-le,s.v.p.',
    sendError: "l'envoi n'est pas réussi ! renvoyez-le,s.v.p.",
    resetPassword: 'réinitialiser le mot de passe',
    requiredEmail: 'entrez l’adresse d’e-mail correct',
    logOut: 'sortie',
    choose: 'choisissez',
    introduction: 'introduction',
    baseInfo: 'informations de base',
    city: 'arrondissement, ville, province',
    oldPassword: 'ancien mot de passe',
    newPassword: 'nouveau mot de passe',
    changeSuccess: 'modifié avec succès',
    checkPass: 'confirmer le mot de passe',
    oldphone: 'ancien numéro de portable',
    newphone: 'nouveau numéro de portable',
    oldCode: 'ancien numéro de portable',
    Name: 'nom',
    editRow: 'opération',
    addInvoiceAddress: 'ajouter un adresse postale de facturation',
    addAddress: 'ajouter une adresse de livraison',
    editInvoiceAddress: "modifier l'adresse postale de facturation",
    editAddress: 'modifier l’adresse de livraison',
    inputHospitalAddress: "entrez la désignation de l'hôpital",
    inputHospitalAddress: "entrez l’adresse de l'hôpital",
    casesn: 'numéro de série',
    casecode: 'numéro',
    age: 'âge',
    rightdown: 'inférieur et droit',
    leftdown: 'inférieur et gauche',
    over2m: 'plus de 2mm',
    isrequerdtosmartee: 'existe-t-il une communication avec le service médical Smartee? ',
    isMSGRead: 'lu',
    isMSGunRead: 'Non lu',
    sysNotise: 'rappel du système',
    processNotise: "rappel d'avancement",
    stepsNotise: "rappel de l'étape",
    patientGender: 'sélectionnez le sexe',
    inputpatientAge: "entrez l'âge",
    inputHospitalName: "entrez la désignation de l'hôpital",
    filetyps: 'Cargar como un paquete comprimido (el tipo de archivo debe ser .rar / .zip)'

}


// WEBPACK FOOTER //
// ./src/lang/fr.js